import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import bandsTrainers from '../data/trainers/BandsTrainers';
import './BandsTrainers.css';

const BandsTrainers = () => {
    const navigate = useNavigate();

    // Get bands trainers from the trainers data file
    const bandsTrainersData = Object.values(bandsTrainers);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('Bands trainer selected:', trainer);

        // 🎵 PLAY BANDS TRAINER SELECTION SOUND
        soundManager.playSound('bodyweightSet', 0.7);

        // Navigate to the bands trainer page
        navigate(`/bands-trainer/${trainer.id}`);
    };

    // Handle back to train categories
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/train-categories');
    };

    return (
        <div className="bands-trainers-container">
            {/* Yellow pulsating background */}
            <div className="yellow-pulsing-background"></div>

            <header className="bands-trainers-header">
                <button
                    className="back-to-categories-button"
                    onClick={handleBackToCategories}
                >
                    ← Back to Categories
                </button>

                <div className="header-content">
                    <h1>Pick Your Bands Trainer</h1>
                    <p>Dynamic coaches for resistance band training excellence</p>
                    <div className="category-stats">
                        <span className="stat-badge">6 Band Experts</span>
                        <span className="stat-badge">36 Resistance Programs</span>
                        <span className="stat-badge">Versatile Training</span>
                    </div>
                </div>
            </header>

            <div className="bands-trainers-grid">
                {bandsTrainersData.map((trainer) => (
                    <div
                        key={trainer.id}
                        className="bands-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                    >
                        <div className="bands-trainer-image-section">
                            <div
                                className="bands-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                <div className="experience-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        <div className="bands-trainer-info-section">
                            <h3 className="bands-trainer-name">{trainer.name}</h3>
                            <h4 className="bands-trainer-specialization">{trainer.specialization}</h4>
                            <p className="bands-trainer-description">{trainer.intro?.substring(0, 120)}...</p>

                            <div className="bands-trainer-details">
                                <div className="detail-item">
                                    <span className="detail-icon">🎯</span>
                                    <span className="detail-text">{trainer.category} specialist</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-icon">📋</span>
                                    <span className="detail-text">{trainer.programs?.length || 6} Programs</span>
                                </div>
                            </div>

                            <div className="bands-trainer-action">
                                <button className="select-bands-trainer-button">
                                    Band Programs
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <footer className="bands-trainers-footer">
                <div className="bands-info">
                    <h3>🎯 Resistance Band Mastery</h3>
                    <div className="bands-benefits-grid">
                        <div className="bands-benefit-item">
                            <span className="benefit-icon">🏃‍♂️</span>
                            <div>
                                <strong>Versatile Training</strong>
                                <p>Full-body workouts with portable resistance equipment</p>
                            </div>
                        </div>
                        <div className="bands-benefit-item">
                            <span className="benefit-icon">⚡</span>
                            <div>
                                <strong>Variable Resistance</strong>
                                <p>Progressive tension for strength and mobility gains</p>
                            </div>
                        </div>
                        <div className="bands-benefit-item">
                            <span className="benefit-icon">🎯</span>
                            <div>
                                <strong>Functional Movement</strong>
                                <p>Train movement patterns for real-world strength</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default BandsTrainers;